import { HostBinding } from '@angular/core';
import { Router } from '@angular/router';

export abstract class Base {
    @HostBinding('class.app-page') addAppPageClass = true;
    private _loaders: number = 0;

    set isLoading(newState: boolean) {
        if (newState === true) {
            this._loaders++;
        }
        else {
            this._loaders--;

            if (this._loaders < 0)
                this._loaders = 0;
        }

        this.setLoading();
    }

    get isLoading(): boolean {
        return this._loaders > 0;
    }

    public resetLoading() {
        this._loaders = 0;
        this.isLoading = false;
    }

    isNew(routeValue: any) {
        return routeValue.toString().toLowerCase() === "create" || routeValue.toString().toLowerCase() === "-1";
    }

    goBack(router: Router, numberToGoBack: number = 1) {
        var splitRoute = router.url.split("/");
        splitRoute.length = splitRoute.length - numberToGoBack;
        router.navigateByUrl(splitRoute.join("/"));
    }

    showError(error?: any, denyRestart?: boolean) {
        this.setError(error, denyRestart);
        this._loaders = 0;
        this.isLoading = false;
    }

    private setLoading() {
        //var loadingEle = document.getElementsByTagName("loading-modal")[0];
        //loadingEle.setAttribute("show", this.isLoading.toString());

        document.body.classList.remove('loading-state-on');
        document.body.classList.remove('loading-state-off');
        document.body.classList.add(this.isLoading ? 'loading-state-on' : 'loading-state-off');
    }

    private setError(error?: any, denyRestart?: boolean) {
        var errorEle = document.getElementsByTagName("error-modal")[0];
        var textEle = errorEle.getElementsByClassName("error-desc")[0];
        document.body.classList.add('error-state-active');

        if (denyRestart)
            document.body.classList.add("error-deny-restart");

        if (error) {
            if (typeof error === "object") {
                //TODO: show error message and status code?
                textEle.innerHTML = "error parameter was OBJECT, which is not fully implemented!";
            }
            else if (typeof error === "string") {
                textEle.innerHTML = error;
            }
            else {
                textEle.innerHTML = "An error occurred!";
            }
        }
        else {
            textEle.innerHTML = "An error occurred!";
        }



    }

}
